import { useMemo } from "react";
import { useNavigate } from "react-router";

import useBlobStorageFlag from "hooks/useBlobStorageFlag";
import useOriginFlag from "hooks/useOriginFlag";
import { getIntegrationById, integrationIds } from "views/Account/Integrations/registry";
import { IntegrationId } from "views/Account/Integrations/registry/constants";

import { CommandPaletteActionType, CommandPaletteBucket } from "../types";
import { BUCKET_IDS } from "../constants";

const useCommandPaletteIntegrationsBucket = (): CommandPaletteBucket => {
  const navigate = useNavigate();
  const blobStorageEnabled = useBlobStorageFlag();
  const originEnabled = useOriginFlag();

  const integrationActions = useMemo(
    () =>
      integrationIds
        .map((id) => getIntegrationById(id))
        .filter((integration) => integration?.hasViewScreen)
        // TODO: remove this filter together with the vcs-provider-blob-storage feature flag.
        .filter(
          (integration) => integration!.id !== IntegrationId.BLOB_STORAGE || blobStorageEnabled
        )
        .filter((integration) => integration!.id !== IntegrationId.ORIGIN || originEnabled)
        .map((integration) => ({
          type: CommandPaletteActionType.SIMPLE,
          id: `go-to-integration-${integration!.id}`,
          title: integration!.name,
          keywords: ["integration", "navigate", "go to"],
          bucketId: BUCKET_IDS.INTEGRATIONS,
          icon: integration!.icon,
          onAction: () => navigate(`/integrations/${integration!.id}`),
        })),
    [navigate, blobStorageEnabled, originEnabled]
  );

  return useMemo(
    () => ({
      id: BUCKET_IDS.INTEGRATIONS,
      title: "Integrations",
      order: 3,
      getActions: () => integrationActions,
    }),
    [integrationActions]
  );
};

export default useCommandPaletteIntegrationsBucket;
